import { Contact, MonitorUp, UserRound } from "lucide-react";

export function AboutJoeSection() {
  return (
    <section className="about-section section-pad" id="ueber-mich">
      <div className="about-portrait">
        <img src="/images/profile.webp" alt="Joe, persönlicher Mathe-Nachhilfelehrer" loading="lazy" />
      </div>
      <div className="about-copy">
        <div className="eyebrow">Mathe Wissen direkt aus dem Studium</div>
        <h2>Hi, ich bin Joe.</h2>
        <p>
          Ich studiere Informatik und Landschaftsarchitektur und gebe persönliche
          Online-Mathenachhilfe. Mir ist wichtig, dass du nicht einfach Formeln
          auswendig lernst, sondern wirklich verstehst, warum etwas funktioniert.
        </p>
        <ul className="personal-points">
          <li><UserRound aria-hidden="true" /><span><strong>1:1 Unterricht</strong>Volle Aufmerksamkeit für deine Fragen</span></li>
          <li><Contact aria-hidden="true" /><span><strong>Direkter Kontakt</strong>Du sprichst immer persönlich mit mir</span></li>
          <li><MonitorUp aria-hidden="true" /><span><strong>Digitales Whiteboard</strong>Rechenwege entstehen gemeinsam und sichtbar</span></li>
        </ul>
      </div>
    </section>
  );
}
